<template>
  <section class="beta-launch section" id="contact">
    <div class="beta-container bd-grid">
      <!-- Status Badge -->
      <div class="beta-status-badge">
        <span class="status-indicator"></span>
        {{ $t('betaLaunch.status') }}
      </div>

      <!-- Main Content -->
      <div class="beta-content">
        <h2 class="beta-title">{{ $t('betaLaunch.title') }}</h2>
        <p class="beta-subtitle">{{ $t('betaLaunch.subtitle') }}</p>
        
        <!-- Features Grid -->
        <div class="beta-features">
          <div class="feature-card" v-for="(feature, index) in features" :key="index">
            <div class="feature-icon">
              <component :is="feature.icon" />
            </div>
            <h3>{{ $t(`betaLaunch.features.${feature.key}.title`) }}</h3>
            <p>{{ $t(`betaLaunch.features.${feature.key}.desc`) }}</p>
          </div>
        </div>

        <!-- CTA Buttons -->
        <div class="beta-actions">
          <a 
            href="https://beta-invextia.netlify.app/" 
            target="_blank" 
            rel="noopener noreferrer"
            class="beta-cta primary"
            @click="trackBetaClick"
          >
            <span class="cta-text">{{ $t('betaLaunch.cta') }}</span>
            <svg class="cta-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M1 8h14m-6-6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
          
          <button class="beta-cta secondary" @click="showDemo">
            {{ $t('betaLaunch.demo') }}
          </button>
        </div>
      </div>

      <!-- Visual Elements -->
      <div class="beta-visual">
        <div class="phone-mockup">
          <div class="phone-screen">
            <div class="screen-content">
              <div class="app-header">
                <div class="header-balance">
                  <span class="balance-label">Balance total</span>
                  <span class="balance-amount">$2,450,000</span>
                </div>
                <div class="balance-change positive">+12.5%</div>
              </div>
              <div class="pockets-grid">
                <div class="pocket-card savings">
                  <span class="pocket-label">Ahorro</span>
                  <span class="pocket-amount">$980,000</span>
                </div>
                <div class="pocket-card investment">
                  <span class="pocket-label">Inversión</span>
                  <span class="pocket-amount">$1,200,000</span>
                </div>
                <div class="pocket-card expenses">
                  <span class="pocket-label">Gastos</span>
                  <span class="pocket-amount">$270,000</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Floating Elements -->
        <div class="floating-element elem-1">💰</div>
        <div class="floating-element elem-2">📊</div>
        <div class="floating-element elem-3">🎯</div>
      </div>
    </div>
  </section>
</template>

<script>
import sr from '@/scrollreveal.js';

export default {
  name: 'BetaLaunchSection',
  data() {
    return {
      features: [
        { key: 'pockets', icon: 'WalletIcon' },
        { key: 'ai', icon: 'BrainIcon' },
        { key: 'automation', icon: 'ZapIcon' }
      ]
    };
  },
  mounted() {
    this.initAnimations();
  },
  methods: {
    initAnimations() {
      sr.reveal('.beta-status-badge', { 
        delay: 100,
        duration: 600,
        origin: 'top',
        distance: '20px'
      });
      sr.reveal('.beta-title', { 
        delay: 200,
        duration: 800
      });
      sr.reveal('.beta-subtitle', { 
        delay: 300,
        duration: 800
      });
      sr.reveal('.feature-card', { 
        delay: 400,
        duration: 600,
        interval: 100,
        origin: 'bottom',
        distance: '30px'
      });
      sr.reveal('.beta-actions', { 
        delay: 600,
        duration: 800
      });
      sr.reveal('.beta-visual', { 
        delay: 800,
        duration: 1000,
        origin: 'right',
        distance: '50px'
      });
    },
    trackBetaClick() {
      console.log('Beta CTA clicked');
    },
    showDemo() {
      console.log('Show demo clicked');
    }
  },
  components: {
    WalletIcon: {
      template: `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7"/>
          <path d="M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>
          <path d="M16 16h.01"/>
        </svg>
      `
    },
    BrainIcon: {
      template: `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/>
          <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/>
        </svg>
      `
    },
    ZapIcon: {
      template: `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2"/>
        </svg>
      `
    }
  }
};
</script>

<style scoped src="@/styles/Contact-Section.css"></style>
